/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommunityManagerResponse
 */
export interface CommunityManagerResponse {
    /**
     * 
     * @type {string}
     * @memberof CommunityManagerResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityManagerResponse
     */
    fullname: string;
}

/**
 * Check if a given object implements the CommunityManagerResponse interface.
 */
export function instanceOfCommunityManagerResponse(value: object): value is CommunityManagerResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullname' in value) || value['fullname'] === undefined) return false;
    return true;
}

export function CommunityManagerResponseFromJSON(json: any): CommunityManagerResponse {
    return CommunityManagerResponseFromJSONTyped(json, false);
}

export function CommunityManagerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommunityManagerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullname': json['fullname'],
    };
}

export function CommunityManagerResponseToJSON(value?: CommunityManagerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'fullname': value['fullname'],
    };
}

